import { APPLICATION_ROUTES } from "./routes";

/**
 * The address Google is told to come back to.
 *
 * One expression, because the two ends must agree byte for byte: the value sent with the
 * authorization request and the value sent with the exchange are compared by Google, and a mismatch
 * rejects every sign-in. They were built by different expressions in different files — one with a
 * fallback to the current origin and one without — and nothing compared them.
 */
export const oauthCallbackUrl = (): string =>
	`${import.meta.env.VITE_BASE_URL || window.location.origin}${APPLICATION_ROUTES.OAUTH_GMAIL}`;
